<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
  <path d="M3 4h10a1 1 0 1 0 0-2H3a1 1 0 1 0 0 2Zm10 5H3a1 1 0 1 1 0-2h10a1 1 0 1 1 0 2ZM3 14a1 1 0 1 1 0-2h4a1 1 0 1 1 0 2H3Z"/>
</svg>
